import React, { useEffect, useRef, useState } from "react";

// Mount expensive below-the-fold sections as the user approaches them, once only.
export default function DeferredSection({ children, label, minHeight = 420, rootMargin = "300px" }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!window.IntersectionObserver) {
      setVisible(true);
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        setVisible(true);
        observer.disconnect();
      }
    }, { rootMargin });
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [rootMargin]);
  return <section ref={ref} className="w-full" aria-label={label}
    style={{ minHeight }}>
    {visible ? children : <div className="p-4 text-gray-500">{label}</div>}
  </section>;
}
